import Rule from "../../../common/rule";

/**
 * A score ended this possession without a change of possession during the
 * play: a made field goal (whose drive end is declared only when the kick
 * stands) or a safety. A touchdown ends the drive too, but the try follows,
 * so it is not a handover. Gate only; what follows the score is decided by
 * the children (PSTATS-1381).
 */
export default class ScoreEndedPossession extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(gameContext, ruleContext, eventConfiguration, { play }) {
        return (
            !!ruleContext.isSafety ||
            (!!ruleContext.driveEnd?.isActive && !gameContext.triggerPAT)
        );
    }
}
